import { InventoryTransferUpdateDTO } from "../../../types/inventory/transfer/InventoryTransferTypes";

export interface ValidationErrors {
  [key: string]: string;
}

export const validateInventoryTransferUpdate = (
  _payload: InventoryTransferUpdateDTO
): ValidationErrors => {
  // Sin validaciones adicionales: solo se edita el motivo.
  return {};
};
